import { PlatformApi } from '~/services/api/platform'

export class DogBreedService extends PlatformApi {
  async getAll() {
    return await this.get('/dog-breed')
  }

  async create() {
    return await this.post('/dog-breed/admin')
  }

  async update(breedId) {
    return await this.put(`/dog-breed/admin/${breedId}`)
  }

  async deleteBreed(breedId) {
    return await this.delete(`/dog-breed/admin/${breedId}`)
  }
}
